import { render, staticRenderFns } from "./news-sticky.vue?vue&type=template&id=d1bb9d08&scoped=true"
import script from "./news-sticky.vue?vue&type=script&lang=ts"
export * from "./news-sticky.vue?vue&type=script&lang=ts"
import style0 from "./news-sticky.vue?vue&type=style&index=0&id=d1bb9d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bb9d08",
  null
  
)

export default component.exports